var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-overlay"},[_c('spinner-icon',{staticClass:"loading-overlay__icon",class:_vm.classObject,attrs:{"viewBox":"0 0 32 32"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }